// 📂 src/api/auth.ts
import axiosInstance from './axiosInstance';

export type UserProfile = {
  id: number;
  username: string;
  email: string;
};

type TokenResponse = {
  accessToken: string;
  refreshToken: string;
};

type KakaoLoginResponse = {
  url: string;
};

const frontRedirectUri = `${window.location.origin}/auth/callback`;

// ✅ 카카오 로그인 URL 요청 함수
export const kakaoLogin = async (): Promise<KakaoLoginResponse> => {
  const response = await axiosInstance.get<KakaoLoginResponse>(
    '/api/allbadeum/v1/oauth/kakao/login',
    {
      params: { frontRedirectUri },
    },
  );

  return response.data; // ✅ 이제 .url 사용 가능
};

// ✅ 카카오 인증 코드로 토큰 요청 함수
export const getAccessToken = async (code: string): Promise<TokenResponse> => {
  const response = await axiosInstance.get<TokenResponse>(
    '/api/allbadeum/v1/oauth/kakao/callback',
    {
      params: { code, frontRedirectUri },
    },
  );

  const { accessToken, refreshToken } = response.data;

  if (!accessToken) {
    throw new Error('❌ accessToken 없음!');
  }

  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);

  return { accessToken, refreshToken };
};

export const fetchUserProfile = async (): Promise<UserProfile> => {
  const token = localStorage.getItem('accessToken');
  if (!token) throw new Error('❌ 토큰 없음');

  const res = await axiosInstance.get<UserProfile>('/api/allbadeum/v1/user/me', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
